import React, { useEffect, useState,useRef } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Chip } from 'primereact/chip';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { TabPanel } from 'primereact/tabview';
import { TabView } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { DateBodyForTable, } from '../Common/CommonComponents';

//Component
import { TransactionStats } from './TransactionStats';
import { DetailedQrTablePullout } from './DetailedQrTablePullout';
import { DayQrTransactionsChart } from './DayQrTransactionsChart';
// Services
import ApiServices from '../../service/api/ApiServices';
import CommonCal from '../../service/common/CommonCal';

const saved = localStorage.getItem("user");
const initialValue = JSON.parse(saved);

const commonCal = new CommonCal();
const apiServices = new ApiServices();

export const QrTransactionPullout = props => {

    // const [allMachines,setAllMachines] = useState(null)
    const [selectedMachine, setSelectedMachine] = useState(null)
    const [selectedDuration, setSelectedDuration] = useState({ name: 'Today', code: 'today' });
    const [selectedDurationDates, setSelectedDurationDates] = useState(null);
    const [transStats, setTransStats] = useState(null);
    const [transChartData, setTransChartData] = useState([]);
    const [transTableData, setTransTableData] = useState([]);
    const [dates, setDates] = useState(null)
    const [selectedCustomDate, setSelectedCustomDate] = useState(null)
    const [customFilterDialog, setCustomFilterDialog] = useState(false);
    const [allAccounts, setAllAccounts] = useState([{ siteName: 'All', code: 'all' }])
    const [selectedAccount, setSelectedAccount] = useState({ siteName: 'All', code: 'all' })
    const [loading, setLoading] = useState(true)
    const [activeIndex, setActiveIndex] = useState(0)
    const [globalFilter, setGlobalFilter] = useState(null);
    const [transactionData, setTransactionData] = useState(null);
    const [allTransactionData, setAllTransactionData] = useState(null);
    const [despensed, setDespensed] = useState({ name: 'All', code: 'all' })
    const [allMachines, setAllMachines] = useState([{ id: 'All' }])
    
    
    const dt = useRef(null);

     const despensedOptions = [
        { name: 'All', code: 'all' },
        { name: 'Dispensed', code: 'dispensed' },
        { name: 'Non-Dispensed', code: 'non_dispensed' }
    ]
    


    // useEffect(()=>{
    //     console.log(props.allMachines)
    //     getFiltered(props.allMachines)
    // },[props.allMachines])

    useEffect(() => {
        getByUser(props.allAccounts)
        setDespensed({ name: 'All', code: 'all' })
    }, [props.allAccounts])

    const getByUser = (data) => {
        if (data) {

            const response = commonCal.getDates()
            setDates(response)
            setSelectedDurationDates({ startDate: response.startToday, endDate: response.endToday })

            if (initialValue?.userType == 'customer') {

                const accData = data?.filter((x) => { return x.userid == initialValue?.userid })
                setAllAccounts(accData)
                setSelectedAccount(data[2])
                getTransactionByUser({ cves_details: data[2].cves_details,customer:data[2].customer,siteName:data[2].siteName, date: { startDate: response.startToday, endDate: response.endToday } })

            } else {
                setAllAccounts([...allAccounts, ...data])
                setSelectedAccount(data[2])
                getTransactionByUser({ cves_details: data[2].cves_details,customer:data[2].customer,siteName:data[2].siteName, date: { startDate: response.startToday, endDate: response.endToday } })
            }
        }
    }

    const getTransactionByUser = async (data) => {
        setLoading(true)
        const response = await apiServices.PaytemqrTransactionPullout(data);
        console.log(response?.data?.data);
        setTransactionData(response?.data?.data)
        setAllTransactionData(response?.data?.data)
        const unique = [...new Set(response?.data?.data.map(item => item.machineId))];
        const machineData = unique.map((x) => { return { 'id': x } })
        const x = [{ id: 'All' }]
        setAllMachines([...x, ...machineData])

        setLoading(false)
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    }

    const changeAcc = (e) => {
        console.log(e.value);
        setSelectedAccount(e.value)
        if (e.value?.company == 'All') {
            getTransactionByUser({ cves_details: e.value.cves_details,customer:e.value.customer,siteName:e.value.siteName, date: selectedDurationDates })
            setActiveIndex(0)
        } else {
            getTransactionByUser({ cves_details: e.value.cves_details,customer:e.value.customer,siteName:e.value.siteName, date: selectedDurationDates })
        }
    }

    const changeDuration = (e) => {
        e.value.code !== 'custom' && setSelectedDuration(e.value);
        const userData = selectedAccount && { "userType": selectedAccount.userType, "userid": selectedAccount.userid }
        const isSingleAcc = selectedAccount.company == 'All' ? false : true;

        switch (e.value.code) {

            case 'till_date': {
                isSingleAcc ? getTransactionByUser({ cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer })
                setSelectedDurationDates(null)
                break;
            }
            case 'today': {
                const date = { startDate: dates?.startToday, endDate: dates.endToday }
                isSingleAcc ? getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer })
                setSelectedDurationDates(date)
                break;
            }
            case 'yesterday': {
                const date = { startDate: dates?.YestStart, endDate: dates.EndStart }
                isSingleAcc ? getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer })
                setSelectedDurationDates(date)
                break;
            }
            case 'this_week': {
                const date = { startDate: dates?.weekstart, endDate: dates.weekEnd }
                isSingleAcc ? getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer })
                setSelectedDurationDates(date)
                break;
            }
            case 'this_month': {
                const date = { startDate: dates?.monthStart, endDate: dates.endThisMonth }
                selectedAccount ? getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer })
                setSelectedDurationDates(date)
                break;
            }
            case 'last_month': {
                const date = { startDate: dates?.lastStart, endDate: dates.lastend }
                isSingleAcc ? getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer })
                setSelectedDurationDates(date)
                break;
            }
            case 'custom':
                setCustomFilterDialog(true)
                break;

            default: {
                const date = { startDate: dates?.startToday, endDate: dates.endToday }
                setSelectedDurationDates(date)
                break;
            }
        }
    }


    const changeCustomDate = e => {
        setSelectedCustomDate({ ...selectedCustomDate, [e.target.name]: e.target.value })
    }

    const customSubmit = (e) => {
        e.preventDefault()
        const startt = new Date(selectedCustomDate.start_date).setHours(0, 0, 0, 0);
        const endd = new Date(selectedCustomDate.end_date).setHours(23, 59, 59, 0);
        const date = { startDate: new Date(startt).toISOString(), endDate: new Date(endd).toISOString() };
        // updateData({id:selectedMachine?.id,date:date})
        (selectedAccount?.company == 'All') ? getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer }) : getTransactionByUser({ date,cves_details:selectedAccount.cves_details,siteName:selectedAccount.siteName,customer:selectedAccount.customer });
        setSelectedDurationDates(date)
        setCustomFilterDialog(false)
        setSelectedDuration(null)
    }

    const leftToolbarTemplate = () => {
        return (
            <>
                {/* <Chip label={`Total No. Of CTVM : ${allMachines?allMachines?.length:'-'}`}  icon="pi pi-angle-double-right" className="p-mr-2 p-mb-2" /> */}
                {/* <Chip label={`Total No. Of Paytm CTVM : ${allMachines ? allMachines?.filter((x)=>{ return x.mchmode && x.mchmode.paymode.online == true}).length :'-'}`} icon="pi pi-angle-double-right" className="p-mr-2 p-mb-2" />                 */}
            </>
        )
    }


    const rightToolbarTemplate = () => {
        return (
            <>
                <div className="p-inputgroup p-mr-2">
                    <Button className='custom-group-btn' label="ACC" />
                    <Dropdown value={selectedAccount} onChange={(e) => { changeAcc(e) }} options={allAccounts} optionLabel="siteName" placeholder="Select Filter" filter
                        className="p-m-0 multiselect-custom" />
                </div>

                {/* <div className="p-inputgroup p-mr-2">
                    <Button className='custom-group-btn' label="CTVM" />
                    <Dropdown value={selectedMachine} onChange={(e)=>{changeMachine(e)}} options={allMachines} optionLabel="displayLabel" placeholder="Select Filter" filter
                        className="p-m-0 multiselect-custom" />
                </div> */}

                <div className="p-inputgroup ">
                    <Button className='custom-group-btn' label="DURATION" />
                    <Dropdown value={selectedDuration} onChange={(e) => { changeDuration(e) }} options={props.durationOptions} optionLabel="name" placeholder="Custom" filter
                        className="p-m-0 multiselect-custom" />
                </div>
            </>
        )
    }

    const srBodyTemplate = (rowData, props) => (
    <>
        <span className="p-column-title">{props?.header ?? ''}</span>
        {props?.rowIndex + 1 ?? ''}
    </>
);

const commonBodyTemplate = (rowData, props) => (
    <>
        <span className="p-column-title">{props?.header ?? ''}</span>
        {rowData?.[props?.field] ?? '-'}
    </>
);

const txnIdBodyTemplate = (rowData, props) => (
    <>
        <span className="p-column-title">{props?.header ?? ''}</span>
        {rowData?.txndetails?.[props?.field] ?? rowData?.txndetails?.TXNID ?? '-'}
    </>
);

const txnStatusBodyTemplate = (rowData, props) => {
    const status = rowData?.[props?.field] ?? rowData?.txndetails?.resultInfo?.resultStatus ?? 'UNKNOWN';
    let severity = 'info';

    if (status === 'SUCCESS') severity = 'success';
    else if (status === 'FAILED') severity = 'danger';

    return (
        <>
            <span className="p-column-title">{props?.header ?? ''}</span>
            <Chip label={status} severity={severity} />
        </>
    );
};

 const changeDispense = (e) => {
        setDespensed({ name: 'All', code: 'all' })
        switch (e.value.code) {
            case 'dispensed': {
                const data = allTransactionData.filter((x) => { return x.dispensed == true })
                // const data = transactionData.filter((x)=>{ return x.dispensed == true})
                setTransactionData(data)
                setDespensed({ name: 'Dispensed', code: 'dispensed' })
                break;
            }
            case 'non_dispensed': {
                const data = allTransactionData.filter((x) => { return x.dispensed == false })
                // const data = transactionData.filter((x)=>{ return x.dispensed == false})
                setDespensed({ name: 'Non-Dispensed', code: 'non_dispensed' })
                setTransactionData(data)
                break;
            }
            default:
                const data = allTransactionData 
                setDespensed({ name: 'All', code: 'all' })
                setTransactionData(data)
                break;
        }
    }

    const changeMachine = (e) => {
        setSelectedMachine(e.value)
        if (e.value.id == 'All') {
            const data = despensed.code == 'all' ? allTransactionData : allTransactionData.filter((x) => { return x.dispensed == (despensed.code == 'dispensed' ? true : false) })
            setTransactionData(data)
        } else {
            const data = despensed.code == 'all' ? allTransactionData.filter((x) => { return x.machineId == e.value.id }) : allTransactionData.filter((x) => { return x.machineId == e.value.id && x.dispensed == (despensed.code == 'dispensed' ? true : false) })
            setTransactionData(data)
        }
    }


     const header = (
            <div className="table-header">
                <span className='p-input-icon-right'>
                    <div className="p-inputgroup p-mr-2">
                        <Button className='custom-group-btn' label="CVES" />
                        <Dropdown value={selectedMachine} onChange={changeMachine} options={allMachines} optionLabel="id" placeholder="Select CVES" filter
                            className="p-m-0 multiselect-custom" />
    
                        <Button className='custom-group-btn p-ml-2' label="STATUS" />
                        <Dropdown value={despensed} onChange={changeDispense} options={despensedOptions} optionLabel="name" placeholder="Select Filter" filter
                            className="p-m-0 multiselect-custom" />
                    </div>
                </span>
                <span className="p-input-icon-left">
                    <div className="p-inputgroup">
                        <Button className='custom-group-btn' icon="pi pi-search" />
                        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                        <Button icon="pi pi-download" className='custom-group-btn p-button-rounded p-mt-2 p-mx-4' onClick={exportCSV} />
                    </div>
                </span>
            </div>
        );

    return (
        <>
            <Toolbar className="p-mb-4 p-toolbar" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

            <div className="card">

                {
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="DETAILED QR TRANSACTION">
                            {/* <DetailedQrTablePullout transTableData={transTableData} getDetailedTransactions={getDetailedTransactions} selectedDurationDates={selectedDurationDates} selectedAccount={selectedAccount} /> */}

                            <DataTable value={transactionData}
                                dataKey="id" ref={dt} paginator rows={25} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Transactions"
                                globalFilter={globalFilter} emptyMessage="No Data found." header={header} loading={loading}
                                exportFilename={`Detailed QR Transaction`}>
                                <Column field="srid" header="Sr.No." sortable body={srBodyTemplate} exportable={false}></Column>
                                <Column field="machineId" header="CVES Id" sortable body={commonBodyTemplate}></Column>
                                {/* <Column field="beverage" header="Beverage" sortable body={commonBodyTemplate}></Column> */}
                                <Column field="amount" header="Amount Per Cup" sortable body={commonBodyTemplate}></Column>
                                <Column field="Date" header="QR Transaction Date" sortable body={DateBodyForTable}></Column>
                                {/* <Column field="username" header="User Name" sortable body={commonBodyTemplate}></Column> */}
                                <Column field="orderId" header="Order Id" sortable body={commonBodyTemplate}></Column>
                                <Column field="resultStatus" header="Result Status" sortable body={txnStatusBodyTemplate} exportable={false}></Column>
                                <Column field="txnId" header="QR Transaction Id" sortable body={txnIdBodyTemplate} style={{ wordWrap: 'break-word' }} exportable={false}></Column>
                            </DataTable>
                        </TabPanel>
                    </TabView>
                }

            </div>

            <Dialog visible={customFilterDialog} style={{ width: '550px' }} header="Custom Filter" onHide={() => { setCustomFilterDialog(false) }} modal className="p-fluid">
                <form onSubmit={customSubmit}>
                    <div className='p-grid'>
                        <div className='p-col-6'>
                            <label htmlFor="from">From</label>
                            <InputText id="from" type="date" name='start_date' value={selectedCustomDate?.start_date} onChange={changeCustomDate} required autoFocus />
                        </div>
                        <div className='p-col-6'>
                            <label htmlFor="to">To</label>
                            <InputText id="to" type="date" name='end_date' value={selectedCustomDate?.end_date} onChange={changeCustomDate} required />
                        </div>
                    </div>
                    <div className="p-dialog-footer p-mt-4">
                        <button className="p-button p-button p-button-danger" onClick={() => { setCustomFilterDialog(false) }}><span className="p-button-icon p-c pi pi-times p-button-icon-left"></span><span className="p-button-label p-c">Cancel</span><span className="p-ink"></span></button>
                        <button className="p-button p-button-success" type="submit"><span className="p-button-icon p-c pi pi-check p-button-icon-left"></span><span className="p-button-label p-c">Submit</span><span className="p-ink"></span></button>
                    </div>
                </form>
            </Dialog>


        </>
    )
}